<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title">
                                    <h4 class="mb-4">创建账号</h4>
                                    <p>填写信息创建新的账号</p>
                                </div>
                                <div class="clearfix">
                                    <vs-input
                                        label-placeholder="Username"
                                        name="用户名"
                                        placeholder="用户名"
                                        v-model="username"
                                        class="w-full" />
									
									<vs-input
									    name="手机号"
									    type="number"
									    label-placeholder="手机号"
									    placeholder="手机号"
									    v-model="phone"
									    class="w-full mt-6" />
									
                                    <vs-input
                                        name="邮箱"
                                        type="email"
                                        label-placeholder="邮箱"
                                        placeholder="邮箱"
                                        v-model="email"
                                        class="w-full mt-6" />
									
                                    <vs-input
                                        ref="password"
                                        type="password"
                                        name="password"
                                        label-placeholder="密码"
                                        placeholder="密码"
                                        v-model="password"
                                        class="w-full mt-6" />

                                    <vs-input
                                        type="password"
                                        data-vv-as="password"
                                        name="confirm_password"
                                        label-placeholder="确认密码"
                                        placeholder="确认密码"
                                        v-model="confirm_password"
                                        class="w-full mt-6" />

                                    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">我接受信息注册使用协议</vs-checkbox>
                                    <vs-button  type="border" to="/pages/login" class="mt-6">去登录</vs-button>
                                    <vs-button class="float-right mt-6" @click="registerUser" >注册</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
		<!-- 弹窗 -->
		<div class="code">
			 <vs-prompt
			    vs-title="邮箱验证"
			 	@vs-cancel="val=''"
			 	@vs-accept="acceptAlert"
			 	@vs-close="val=''"
				vs-accept-text="确定"
				vs-cancel-text="取消"
			 	:vs-active.sync="activePrompt">
			 	<div class="con-exemple-prompt">
			 		<span>已发送验证码到你的手机,请输入：</span>
			 	<vs-input placeholder="邮箱验证码" vs-placeholder="Code" v-model="val" class="mt-3 w-full" />
			 	</div>
			 </vs-prompt>
		</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            username: '',
            email: '',
            password: '',
            confirm_password: '',
			phone:'',
			val:'',  //邮箱验证
			activePrompt:false,
            isTermsConditionAccepted: true
        }
    },
	mounted() {
	},
    methods: {
        registerUser() {
            if(this.username==''||this.phone==''||this.email==''||this.password==''||this.confirm_password==''){
				this.$vs.notify({
				  color:'warning',
				  title:'提示',
				  text:'请将内容填写完整'
				})
				return false;
			}
			if(this.confirm_password!=this.password){
				this.$vs.notify({
				  color:'warning',
				  title:'提示',
				  text:'两次输入密码不一致'
				})
				return false;
			}
			var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
			var reg=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
			if (!myreg.test(this.phone)||!reg.test(this.email)) {
			    this.$vs.notify({
			      color:'warning',
			      title:'提示',
			      text:'手机号或邮箱格式不正确'
			    })
			    return false;
			}
			this.$api.getphonecode({phone:this.phone}).then(res=>{
				console.log("验证码发送",res);
				if(res.code==0){
					this.$vs.notify({
					  color:'success',
					  title:'提示',
					  text:"手机验证码已发送"
					})
					this.activePrompt=true;
				}else{
					this.$vs.notify({
					  color:'warning',
					  title:'提示',
					  text:res.message
					})
				}
			}).catch(err=>{console.log("网络错误",err)})
        },
		acceptAlert(){
			var that=this;
			this.$api.Register({code:this.val,email:this.email,phone:this.phone,name:this.username,password:this.password}).then(res=>{
				console.log("注册结果",res);
				if(res.code==0){
					this.$vs.notify({
					  color:'success',
					  title:'提示',
					  text:"注册成功"
					})
					this.$router.push({path:'/login'});
				}else{
					this.$vs.notify({
					  color:'warning',
					  title:'提示',
					  text:res.message
					})
				}
				this.val="";
			}).catch(err=>{console.log("网络错误",err)})
		},
	
        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: '登录提示',
                text: '当前账号已存在',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },
    }
}
</script>
<style lang="stylus">
	.code{
		width 200px;
		height 300px
	}
</style>
